// Module
var code = `<footer> <ng-content></ng-content> </footer> `;
// Exports
export default code;